import { ApplicationRef, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { first } from 'rxjs';
import { StyleClassModule } from 'primeng/styleclass';
import { Store } from '@ngxs/store';
import { BlockUIState, MessagesState, Users, UserState, } from '@harlowe/core';
import { AsyncPipe, CommonModule, NgIf } from '@angular/common';
import { AvatarModule } from 'primeng/avatar';
import { MenubarModule } from 'primeng/menubar';
import { MenuModule } from 'primeng/menu';
import { PanelMenuModule } from 'primeng/panelmenu';
import { MenuItem, PrimeNGConfig } from 'primeng/api';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';
import { RippleModule } from 'primeng/ripple';
import { ButtonModule } from 'primeng/button';
import { environment } from '../environments/environment';
import { OverlayPanelModule } from 'primeng/overlaypanel'
import { ToastModule } from 'primeng/toast'
import { SidebarModule } from 'primeng/sidebar'
import { MsalService } from '@azure/msal-angular';
import { UserInterfaceState } from './state/ui/ui-state';
import { UserInterface } from './state/ui/ui-actions';
import { ClaimSidecarComponent } from './components/main/claim-sidecar/claim-sidecar.component';
import { BlockUIModule } from 'primeng/blockui'
import { EmailSidebarComponent } from './components/main/email-sidebar/email-sidebar.component';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { MessageListComponent } from "@harlowe/core";
import { AutoCompleteModule } from "primeng/autocomplete";
import { BadgeModule } from 'primeng/badge';


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, StyleClassModule, AsyncPipe, NgIf, CommonModule,
    AvatarModule, MenubarModule, InputTextModule, FormsModule, RippleModule,
    PanelMenuModule, ButtonModule, MenuModule, OverlayPanelModule, ToastModule,
    SidebarModule, ClaimSidecarComponent, BlockUIModule, EmailSidebarComponent,
    TieredMenuModule, MessageListComponent, OverlayPanelModule, AutoCompleteModule,
    BadgeModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit
{

  @ViewChild(MessageListComponent) messageListComponent?: MessageListComponent;
  title = "htc";
  //Observbable for the logged in user
  currentUser$ = this._store.select(UserState.currentUser);
  uiBlocked$ = this._store.select(BlockUIState.uiBlocked);
  sidebarVisible$ = this._store.select(UserInterfaceState.sidebarVisibility);

  topMenuItems: MenuItem[] = [];
  avatarItems: MenuItem[] = [];
  topMenuSearchValue: string = "";
  rightSidebarVisible: boolean = false;

  emailTab = [{ label: 'Email', icon: 'pi pi-envelope', command: () => { alert('Opening Email...') }}];

  email_sidebar_visible: boolean = false;
  unreadCount: number = 0;

  constructor
  (
    public _store: Store,
    private _appRef: ApplicationRef,
    private primengConfig: PrimeNGConfig,
    private _msal: MsalService,
    private route: ActivatedRoute,
    private router: Router,
  )
  {
    this.sidebarVisible$.subscribe(v => this.rightSidebarVisible = v);

    this._store.select(MessagesState.unreadCount).subscribe(c => this.unreadCount = c);

    //Notify when app is loaded
    this._appRef.isStable.pipe(first((stable) => stable))
    .subscribe
    (
      () => 
      {
        if(environment.harlowe.tealcomp.autologin)
          this._store.dispatch(new Users.AppLoaded());
      }
    )

    var rc = this.router.events.subscribe
    (
      e => 
        {
          if(e instanceof NavigationEnd)
          {
            if(e.url.includes('sidebar'))
              _store.dispatch(new UserInterface.OpenSidebar())
          }
        }
    )

  }

  ngOnInit(): void 
  {

    this.primengConfig.ripple = true;
    


    this.avatarItems = 
    [
      {
        label: 'Logout',
        icon: 'pi pi-power-off',
        command: (event) => this.requestLogout()
      }
    ];


    this.topMenuItems = 
    [
      {
        label: 'Home',
        icon: 'pi pi-home',
        command: (event) => {
            this.router.navigate([''],{replaceUrl:true});
        }
      },
      {
        label: 'File',
        icon: 'pi pi-file',
        items:
        [
          {
            label: 'Referrals',
            icon: 'pi pi-folder',
            items:
            [
              {label: 'New', icon: 'pi pi-plus', command: (event) => window.open(environment.harlowe.tealcomp.referrals.submissionLink)},
              {label: 'Manage', icon: 'pi pi-list', command: (event) =>  this.loadRouteInSidebar('referralManager')},

            ]
          },
          {
            label: 'Encounters',
            icon: 'pi pi-users',
            command: (event) => this.loadRouteInSidebar('encounterManager')

          },
          {
            label: 'Diaries',
            icon: 'pi pi-book',
            command: (event) => this.loadRouteInSidebar('diaryManager')
          }
        ]
      },
      {
        label: 'Utilities',
        icon: 'pi pi-wrench',
        items: 
        [
          {label: 'Providers', icon: 'pi pi-building', command: () => this.router.navigate(['providers'], {replaceUrl: true})},
          {label: 'Customers', icon: 'pi pi-users'},
          {
            label: 'Settings', 
            icon: 'pi pi-cog', 
            items: 
            [ 
              {label: 'Users', icon: 'pi pi-user-edit', command: () => this.router.navigate(['settings'],{replaceUrl:true})}
            ]
          },
          {
            label: 'Email',
            icon: 'pi pi-envelope',
            items:
            [
              {label: 'Templates', icon: 'pi pi-file-edit', command: () => this.router.navigate(['email_templates'],{replaceUrl:true})}
            ]

          },
          {
            label: 'Notifications',
            icon: 'pi pi-bell',
            command: () => this.router.navigate(['notifications'],{replaceUrl:true})
          }
        ]
      },
      {
          label: 'Finance',
          icon: 'pi pi-dollar',
          items: 
          [
            {label: 'TEAL', icon: 'pi pi-money-bill', command: () => this.router.navigate(['finance/encounter'],{replaceUrl:true})}
          ]
      },
      {
          label: 'Reports',
          icon: 'pi pi-briefcase',
          items: []
      }
    ];
  }
  toggleEmailSidebar()
  {
    this.email_sidebar_visible = !this.email_sidebar_visible
  }

  loadRouteInSidebar(routeName: string)
  {
    this._store.dispatch(new UserInterface.LoadRouteInSidebar({route:routeName}));
  }

  requestLogout()
  {
    this._msal.logoutPopup({mainWindowRedirectUri:'https://www.apple.com'})
  }
  
  hideSidebar()
  {
    this._store.dispatch(new UserInterface.CloseSidebar());
  }
  
  handleOverlayShow()
  {
    this.messageListComponent?.refresh();
  }

}
